export default __webpack_public_path__ + "static/SaolText-Regular-4402e844f161cfe931f6ffc6316aa9e2.eot";